<template>
<div>
    <div class="statistics-top-nav">
        <a href="" :class="{ active: showStatistics === 'User' }" @click.prevent="userStatistics()">{{ $t("statisticsView.userStatistics") }}</a>
        <a href="" :class="{ active: showStatistics === 'Event' }" @click.prevent="eventStatistics()">{{ $t("statisticsView.eventStatistics", [eventNumTop]) }}</a>
        <a href="" :class="{ active: showStatistics === 'TopUsers' }" @click.prevent="topEventParticipants()">{{ $t("statisticsView.topEventParticipants", [usersNumTop]) }}</a>
        <a href="" :class="{ active: showStatistics === 'TopOrganizations' }" @click.prevent="topOrganizationStatistics()">{{ $t("statisticsView.allStatistics", [organizationsNumTop]) }}</a>
    </div>
    <div v-if="showStatistics == 'User'"><kk-user-statistics /></div>
    <div v-if="showStatistics == 'Event'"><kk-event-statistics :numTop="eventNumTop" /></div>
    <div v-if="showStatistics == 'TopUsers'"><kk-top-event-participants :numTop="usersNumTop" /></div>
    <div v-if="showStatistics == 'TopOrganizations'"><kk-all-statistics :numTop="organizationsNumTop" /></div>

    <p>
        <a href="" @click.prevent="openMoreStatistics()">{{ $t("statisticsView.moreStatistics") }}</a>
    </p>
</div>

</template>


<script lang="ts">
import { store } from "store";
import xamatron from "xamatron";
import {defineComponent} from "vue";

type StatisticsType = "User" | "Event" | "TopUsers" | "TopOrganizations";

export default defineComponent({
    mounted() {
        this.setTitle();
    },
    data() {
        const showStatistics: StatisticsType = "User";

        return {
            store: store,
            showStatistics,
            eventNumTop: 50,
            usersNumTop: 50,
            organizationsNumTop: 10
        };
    },
    computed: {
        locale() {
            return this.$i18n.locale;
        }
    },
    methods: {
        setTitle() {
            store.page.title = this.$t("statisticsView.title") as string;
        },
        userStatistics() {
            this.showStatistics = "User";
        },
        eventStatistics() {
            this.showStatistics = "Event";
        },
        topEventParticipants() {
            this.showStatistics = "TopUsers";
        },
        topOrganizationStatistics() {
            this.showStatistics = "TopOrganizations";
        },
        openMoreStatistics() {
            xamatron.openURL(this.$getSiteUrl("public/results"));
        }
    }
})

</script>